// The value needs to be one of URITypeMap from the @spotify-internal/uri lib
export enum CONTENT_TYPES {
  TRACK = 'track',
  ALBUM = 'album',
  SHOW = 'show',
  EPISODE = 'episode',
  USER = 'profile',
  ARTIST = 'artist',
  PLAYLIST = 'playlist-v2',
  PLAYLIST_OLD = 'playlist',
  ARTIST_VIDEO = 'expression',
  POLL = 'poll',
  COMMENT = 'comment',
  MERCH = 'merch',
  EXPRESSION = 'expression',
  CHAT_MESSAGE = 'chat-message',
  SUPPLEMENTARY_MATERIAL = 'supplementarymaterial',
}
